import { styled, Box, Stack } from '../../../../base';

export const StyledCardsRow = styled(Stack)(({ theme }) => ({
    flexWrap: 'wrap',
    alignItems: 'stretch',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
}));

export const StyledCardItem = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flex: '1 1 auto',
    minWidth: 200,
    paddingInlineEnd: theme.spacing(2),
    '&:not(:last-of-type)': {
        borderInlineEnd: `1px solid ${theme.palette.divider}`,
    },
    [theme.breakpoints.down('lg')]: {
        '&:not(:last-of-type)': {
            borderInlineEnd: 'none',
        },
    },
}));

export const StyledIconCircle = styled(Box)(({ theme }) => ({
    borderRadius: '50%',
    background: `linear-gradient(180deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 86.24%)`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
    width: 45,
    flexShrink: 0,
}));

export const StyledTrendRow = styled(Stack)(({ theme }) => ({
    alignItems: 'center',
    gap: theme.spacing(0.5),
}));
